export const CONSTANT = {
  EVENT: 'Event',
  EVENTS: 'Events',
  SAVE_EVENT: {
    Success: {
      message: 'You have saved this Event,Please go to saved tab for more info',
      type: 'Event update Success',
      color: ''
    },
    Error: {
      message: 'Adding to your saved list failed, please save again',
      type: 'Event update Failed',
      color: 'red'
    },
  },
  UNSAVE_EVENT: {
    Success: {
      message: 'You have un saved this Event, Please go to saved tab for more info',
      type: 'Event update Success',
      color: ''
    },
    Error: {
      message: 'Removing from your saved list failed, please remove again',
      type: 'Event update Failed',
      color: 'red'
    },
  },
  ON_GOING_EVENT: {
    Success: {
      message: 'Success for Going to Event, You marked yourself for going to this event',
      type: 'Going to event',
      color: ''
    },
    Error: {
      message: 'Going to Event request is failed',
      type: 'Going event Failed',
      color: 'red'
    },
  },
  ON_NOT_GOING_EVENT: {
    Success: {
      message: 'You are Not Going to Event, You  marked yourself for not going to this event',
      type: 'Going to event',
      color: ''
    },
    Error: {
      message: 'You are Not Going to Event request failed, You  marked yourself for not going to this event',
      type: 'Going event Failed',
      color: 'red'
    },
  },
  ON_INTERESTED_EVENT: {
    Success: {
      message: 'You are Interested to Event, You  marked yourself for interested for this event',
      type: 'Interested to event',
      color: ''
    },
    Error: {
      message: 'You are Interested to Event but update failed',
      type: 'Interested event Failed',
      color: 'red'
    },
  },
  ON_NOT_INTERESTED_EVENT: {
    Success: {
      message: 'You are Not Interested to Event, You  marked yourself for not Interested in this event',
      type: 'Interested to event',
      color: ''
    },
    Error: {
      message: 'You are Not Interested to Event but update failed',
      type: 'Interested event Failed',
      color: 'red'
    },
  },
  DELETE_EVENT: {
    Success: {
      message: 'You are posted Event is deleted',
      type: 'Event Deleted',
      color: ''
    },
    Error: {
      message: 'Post delete API Failed',
      type: 'Event Deleted Failed',
      color: 'red'
    },
  }
}

export const allTabs = [
  { tabName: 'All', totalLength: 0 },
  { tabName: 'Saved', totalLength: 0 },
  { tabName: 'Going', totalLength: 0 },
  { tabName: 'Interested', totalLength: 0 },
  { tabName: 'Past events', totalLength: 0 },
  { tabName: 'Posted', totalLength: 0 },
]